/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_4_TitleInputs */

const en_terms_section_4_title = /** @type {(inputs: Terms_Section_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Use of Website`)
};

const lv_terms_section_4_title = /** @type {(inputs: Terms_Section_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Mājaslapas lietošana`)
};

/**
* | output |
* | --- |
* | "4. Use of Website" |
*
* @param {Terms_Section_4_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_4_title = /** @type {((inputs?: Terms_Section_4_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_4_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_4_title(inputs)
	return en_terms_section_4_title(inputs)
});